import { GridCellError } from "view/components/TasksList/components/Modals/ResponseModal/forms/GridForm/helpers";
import { useTheme } from "@material-ui/core";

export const indexToLetter: Record<number | "default", string> = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
  4: "E",
  5: "F",
  6: "G",
  7: "H",
  default: "A1",
};

export type ActiveCells = {
  columnIndex: number;
  rowIndex: number;
  isFullRow?: boolean;
  isFullColumn?: boolean;
};
export type ErrorCell = Pick<ActiveCells, "columnIndex" | "rowIndex"> & {
  type: GridCellError;
};
export const border = () => {
  const theme = useTheme();

  return `1px solid ${theme.palette.primary.main}`;
};

export const columnsName = "gridSchema.columns" as const;
export const rowsName = "gridSchema.rows" as const;
